import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";

import { Breadcrumbs, Form, Page } from "components";
import { inhabitantsAPI } from "services/inhabitantsAPI";
import {
  Button,
  FileUploader,
  ImportedQuantity,
  TableError,
} from "../components";

import "./styles.scss";
import CPFImport from "../components/CPFImport";

export default function Create({ location: { pathname } }) {
  const previousPage = pathname.replace("create", "list");

  const breadcrumbs = [
    { name: "Home", to: "/" },
    { name: "PRO", to: "/pro" },
    {
      name: "Listagem de Clientes PRO",
      to: previousPage,
    },
    { name: "Inclusão de Clientes PRO", to: "" },
  ];

  const cleanImport = {
    inhabitant_segment: [],
  };

  const [dataImport, setManualImport] = useState(cleanImport);
  const [bulkImport, setBulkImport] = useState(cleanImport);

  const [isBulk, setIsBulk] = useState(false);
  const [isManual, setIsManual] = useState(false);
  const [loading, setLoading] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [failedImports, setFailedImports] = useState([]);
  const [importedQuantity, setImportedQuantity] = useState(0);

  const readUploadFile = (event) => {
    event.preventDefault();

    const acceptedFiles = ["csv", "xls", "xlsx"];

    const fileType = event.target.files[0].name.split(".")[1];

    if (event.target.files && acceptedFiles.includes(fileType)) {
      const reader = new FileReader();

      reader.onload = ({ target }) => {
        const data = target.result;
        const workBook = XLSX.read(data, {
          type: "array",
        });
        const sheetName = workBook.SheetNames[0];
        const workSheet = workBook.Sheets[sheetName];
        const json = XLSX.utils
          .sheet_to_json(workSheet, {
            raw: false,
          })
          .map((item) => Object.values(item)[0]);

        setBulkImport({
          inhabitant_segment: json.map((cpf) => ({
            document_number: cpf,
          })),
        });
        setIsBulk(true);
      };

      if (event.target.files[0]) {
        reader.readAsArrayBuffer(event.target.files[0]);
      }
    }
  };

  const handleSave = () => {
    const endpoint = "/user/inhabitants/segments/bulk-create";
    const body = isBulk ? bulkImport : dataImport;

    setLoading(true);

    inhabitantsAPI
      .post(endpoint, body, {
        headers: {
          "Accept-Language": "pt-BR",
        },
      })
      .then(
        ({
          data: {
            data: { attributes },
          },
        }) => {
          setLoading(false);
          setFailedImports(attributes["failed_imports"]);
          setImportedQuantity(attributes["imported_quantity"]);
        }
      )
      .catch(() => {
        setLoading(false);
        setImportedQuantity(0);
        setFailedImports([{ cpf: "", reason: "Erro no servidor" }]);
      });

    setManualImport(cleanImport);
    setBulkImport(cleanImport);
    setIsBulk(false);
    setIsManual(false);
  };

  useEffect(() => {
    if (
      dataImport.inhabitant_segment.length ||
      bulkImport.inhabitant_segment.length
    ) {
      setBtnDisabled(false);
    } else setBtnDisabled(true);
  }, [dataImport.inhabitant_segment, bulkImport.inhabitant_segment]);

  useEffect(() => {
    if (dataImport.inhabitant_segment.length) {
      setIsManual(true);
    } else setIsManual(false);
  }, [dataImport.inhabitant_segment]);

  return (
    <Page>
      <Breadcrumbs breadcrumbs={breadcrumbs} />

      <Form className="container-add-pro">
        <header>
          <Page.Title>Inclusão de Clientes PRO</Page.Title>
        </header>

        <CPFImport
          name="imported_cpfs"
          onChange={setManualImport}
          data={dataImport}
          isBulk={isBulk}
        />

        <FileUploader readUploadFile={readUploadFile} isManual={isManual} />

        <ImportedQuantity importedQuantity={importedQuantity} />

        <TableError failedImports={failedImports} />

        <div className="buttons">
          <Link to={previousPage}>
            <Button className="back-btn" btnName="Voltar" type="button" />
          </Link>

          <Button
            className="save-btn"
            btnName={loading ? "Salvando..." : "Salvar"}
            type="button"
            onClick={handleSave}
            disabled={btnDisabled}
          />
        </div>
      </Form>
    </Page>
  );
}
